<form [formGroup]="apiConfigurationGeneralForm" class="form">
    <div class="form-container" [ngClass]="{ readonly: apiConfigurationState.$mode() === FormMode.Reading }">
        <div class="form-item">
            <mat-form-field>
                <mat-label>Nom</mat-label>
                <input matInput type="text" formControlName="name" autocomplete="off" tabindex="1" />
                @if (
                    apiConfigurationGeneralForm.controls['name'].errors &&
                    apiConfigurationGeneralForm.controls['name'].errors['required'] &&
                    (apiConfigurationGeneralForm.controls['name']?.dirty || apiConfigurationGeneralForm.controls['name']?.touched)
                ) {
                    <mat-error>Le champ 'Nom' est obligatoire.</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="form-item">
            <mat-form-field>
                <mat-label>Description</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" formControlName="description" autocomplete="off" tabindex="2"></textarea>
            </mat-form-field>
        </div>
        <div class="form-item">
            <mat-form-field>
                <mat-label>Contexte d'utilisation</mat-label>
                <mat-select formControlName="contextOfUse" tabindex="3">
                    @for (contextOfUse of contextOfUses | keyvalue; track contextOfUse.key) {
                        <mat-option [value]="contextOfUse.key">
                            {{ contextOfUse.value }}
                        </mat-option>
                    }
                </mat-select>
                @if (
                    apiConfigurationGeneralForm.controls['contextOfUse'].errors &&
                    apiConfigurationGeneralForm.controls['contextOfUse'].errors['required'] &&
                    (apiConfigurationGeneralForm.controls['contextOfUse']?.dirty || apiConfigurationGeneralForm.controls['contextOfUse']?.touched)
                ) {
                    <mat-error>Le champ 'Contexte d'utilisation' est obligatoire.</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="form-item">
            <mat-form-field>
                <mat-label>Timeout</mat-label>
                <input matInput type="number" formControlName="timeout" autocomplete="off" tabindex="4" />
            </mat-form-field>
        </div>
    </div>
</form>

<div class="wizard-step-buttons">
    @if (apiConfigurationState.$mode() !== FormMode.Reading) {
        <button mat-raised-button (click)="onCancelClick()">Annuler</button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="apiConfigurationGeneralForm.invalid"
            [ngClass]="{ disabled: apiConfigurationGeneralForm.invalid }"
            (click)="onSaveClick()">
            Enregistrer
        </button>
    }
</div>
